export default __webpack_public_path__ + "static/media/icon-twitter-filled.55db5e7e.svg";